import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { addSurveyQuestion, updateSurveyQuestion } from '../../services/Survey';
import { getAllModules } from '../../services/CourseService';
import { formatSixDigitNumber } from '../../services/CommonService';
import Loader from '../../utility/Loader';

export default function CreateSurvey() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState({ user: { first_name: "" } });
    const [selectedSurvey, setSelectedSurvey] = useState({});
    const [allModules, setAllModules] = useState([]);
    const [courseOptions, setCourseOptions] = useState([]);
    const [moduleOptions, setModuleOptions] = useState([]);

    useEffect(() => {
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {
            setUserDetails(userDetails);
            let surveyData = sessionStorage.getItem('updateSurvey') !== undefined && sessionStorage.getItem('updateSurvey') !== null ? JSON.parse(sessionStorage.getItem('updateSurvey')) : {};
            if (surveyData !== null && surveyData !== undefined && surveyData.id !== undefined) {
                surveyData["module_id"] = parseInt(surveyData["module_id"]);
                surveyData["course_id"] = parseInt(surveyData["course_id"]);
                setSelectedSurvey(surveyData);
                sessionStorage.removeItem('updateSurvey');
            }
            getAllModulesData(userDetails.token, surveyData);
        }
    }, []);

    const getAllModulesData = async (token, surveyData) => {
        setLoading(true);
        const modulesData = await getAllModules(token);
        if (modulesData.error) {
            return [];
        } else {
            let moduleArray = [];
            let courseObj = {};
            for (let i = 0; i < modulesData.data.length; i++) {
                modulesData.data[i]['uid'] = modulesData.data[i]['id'] !== undefined && modulesData.data[i]['id'] !== null ? "UID" + formatSixDigitNumber(modulesData.data[i]['id']) : "";
                moduleArray.push(modulesData.data[i]);
                if (courseObj[parseInt(modulesData.data[i]['course_id'])] === undefined) {
                    courseObj[modulesData.data[i]['course_id']] = { label: modulesData.data[i]['course_name'], value: parseInt(modulesData.data[i]['course_id']) };
                }
                modulesData.data[i]["course_id"] = parseInt(modulesData.data[i]["course_id"]);

            }
            setAllModules(moduleArray);
            setCourseOptions(Object.values(courseObj));
            if (surveyData.course_id !== undefined && surveyData.course_id !== null) {
                handleValueChange("course_id", surveyData.course_id, surveyData, moduleArray)
            }
        }
        setLoading(false);
    };

    const handleValueChange = (name, value, survey, modules) => {
        setSelectedSurvey({
            ...survey,
            [name]: value,
        });

        if (name === 'course_id') {
            let m = [];
            for (let i = 0; i < modules.length; i++) {
                if (modules[i].course_id === value) {
                    m.push({ label: modules[i].module_name, value: modules[i].id });
                }
            }
            setModuleOptions(m);
        }
    };

    const submitSurvey = async (type) => {
        let obj = Object.assign(selectedSurvey);
        obj["customer_id"] = userDetails.user.customer_id;

        if (type === 'add') {
            let resp = await addSurveyQuestion(userDetails.token, obj);
            if (resp.error === false) {
                toast.success("Survey Added Successfully!");
                setSelectedSurvey({
                    ...selectedSurvey,
                    ["id"]: resp.survey_id
                });
                navigate('/admin/managesurveys');
            } else {
                toast.error("Some error occurred while adding survey");
            }
        } else {
            let resp = await updateSurveyQuestion(userDetails.token, obj);

            if (resp.error === false) {
                toast.success("Survey Updated Successfully!");
                navigate('/admin/managesurveys');
            } else {
                toast.error("Some error occurred while updating survey");
            }
        }

    }

    return (
        <div>
            {loading ? (
                <Loader />
            ) : (
                <div className=''>
                    <h3 className='text-2xl text-secondary inter-700 mt-6 lg:mt-0 mb-6 md:mb-4 lg:mb-3 px-6 lg:hidden'>Add New Survey</h3>
                    <form className='w-full lg:w-full xl:w-full'>
                        <div className='pt-10 lg:px-12 px-6 pb-4 bg-[#FDF8F8] border-b border-[#D9D9D9]'>
                            <div className='back-btn flex justify-start mb-5 md:mb-8'>
                                <a onClick={() => navigate('/admin/managesurveys')} className='cursor-pointer w-auto bg-tertiary hover:bg-black flex items-center justify-center px-6 h-7 2xl:h-8 text-white inter-500 text-xs 2xl:text-lg rounded-3xl lg:rounded-full transition duration-300 button-shadow'>Back</a>
                            </div>
                            <div className='form-field w-full md:w-[30%] mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Survey Name <span className='text-[#f00]'>*</span></label>
                                <input type='text' name="survey_name" value={selectedSurvey.survey_name} onChange={(e) => handleValueChange("survey_name", e.target.value, selectedSurvey, allModules)} placeholder='' className='inter-400 text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>
                        </div>
                        <div className='lg:py-10 lg:px-12 py-6 px-6 w-full lg:w-4/5'>
                            <h4 className='text-lg lg:text-2xl 2xl:text-4xl text-[#6F7482] inter-600 mb-0 md:mb-0'>When to show this</h4>
                            <div className='flex justify-between flex-wrap mt-5 md:mt-10'>
                                <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Technology <span className='text-[#f00]'>*</span></label>
                                    <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                        options={courseOptions}
                                        value={courseOptions.find(option => option.value === selectedSurvey.course_id)}
                                        onChange={(values) => handleValueChange("course_id", values.value, selectedSurvey, allModules)}
                                    />
                                </div>
                                <div className='form-field w-full md:w-[45%] mb-5 md:mb-8'>
                                    <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Module <span className='text-[#f00]'>*</span></label>
                                    <Select className='inter-400 bg-[#fbfbfb] text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md'
                                        options={moduleOptions}
                                        value={moduleOptions.find(option => option.value === selectedSurvey.module_id)}
                                        onChange={(values) => handleValueChange("module_id", values.value, selectedSurvey, allModules)}
                                    />
                                </div>

                            </div>
                            <div className='form-field w-full mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Survey Question <span className='text-[#f00]'>*</span></label>
                                <input type='text' name="primary_text" value={selectedSurvey.primary_text} onChange={(e) => handleValueChange("primary_text", e.target.value, selectedSurvey, allModules)} placeholder='' className='inter-400 text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                            </div>

                            <div className='form-field w-full mb-5 md:mb-8'>
                                <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Survey Type <span className='text-[#f00]'>*</span></label>
                                <p>{selectedSurvey.type}</p>
                            </div>

                            {selectedSurvey.type === 'RATING' ? (
                                <div className='flex justify-between flex-wrap w-full md:w-[60%]'>
                                    <div className='form-field w-full md:w-[40%] mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Scale From <span className='text-[#f00]'>*</span></label>
                                        <input type='text' name="option1" value={selectedSurvey.option1} onChange={(e) => handleValueChange("option1", e.target.value, selectedSurvey, allModules)} placeholder='' className='inter-400 text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                    </div>
                                    <div className='form-field w-full md:w-[40%] mb-5 md:mb-8'>
                                        <label className='block mb-2 2xl:mb-3 text-base lg:text-xl 2xl:text-3xl inter-500 text-black'>Scale From To <span className='text-[#f00]'>*</span></label>
                                        <input type='text' name="option2" value={selectedSurvey.option2} onChange={(e) => handleValueChange("option2", e.target.value, selectedSurvey, allModules)} placeholder='' className='inter-400 text-black text-base border-2 border-[#bbb] focus:border-[#B44D71] rounded-md h-10 2xl:h-16 outline-0 w-full py-2.5 2xl:py-5 px-6 2xl:px-10 transition duration-300' required />
                                    </div>
                                </div>
                            ) : (
                                null
                            )}


                            <div className='flex flex-wrap text-center items-center mt-8 2xl:mt-16'>
                                <button type="button" onClick={() => handleValueChange("type", "FREE_TEXT", selectedSurvey, allModules)} className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow md:mb-0 mb-4 md:mr-10'>Free Text</button>

                                <button type="button" onClick={() => handleValueChange("type", "RATING", selectedSurvey, allModules)} className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow md:mb-0 mb-4 md:mr-10'>Rating</button>


                            </div>

                            <div className='flex flex-wrap text-center items-center mt-8 2xl:mt-16'>
                                {selectedSurvey.id === undefined ? (
                                    <button type="button" onClick={() => submitSurvey("add")} className='w-full md:w-auto bg-tertiary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow md:mb-0 mb-4 md:mr-10'>Add Survey</button>

                                ) : (
                                    <button type="button" onClick={() => submitSurvey("update")} className='w-full md:w-auto bg-tertiary hover:bg-black flex items-center justify-center px-10 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow md:mb-0 mb-4 md:mr-10'>Update Survey</button>

                                )}
                            </div>
                        </div>
                    </form>

                </div>
            )}
        </div>
    );
}